<template>
  <a-button-group>
    <a-button
      v-for="unit in periodOptions"
      :key="unit.value"
      :type="period === unit.value ? 'primary' : 'default'"
      @click="setPeriod(unit.value)"
    >
      {{ unit.label }}
    </a-button>
  </a-button-group>
</template>

<script>
export default {
  props: {
    period: {
      type: String,
      required: true
    },
    periodOptions: {
      type: Array,
      required: true
    }
  },
  methods: {
    setPeriod(newPeriod) {
      this.$emit('update:period', newPeriod);
    }
  }
};
</script>
